// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type HideFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from hide-filled.svg
 */
export default function HideFilledIcon(props: HideFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="HideFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="m1.613.21.094.083 14 14a1 1 0 0 1-1.32 1.497l-.094-.083-14-14A1 1 0 0 1 1.613.21m-.038 4.195 3.43 3.429L5 8a3 3 0 0 0 3 3l.166-.006 2.631 2.632C9.923 13.87 8.98 14 8 14c-4.36 0-8-2.6-8-6 0-1.367.588-2.604 1.575-3.596M16 8c0-3.4-3.64-6-8-6-.98 0-1.924.131-2.798.374l2.631 2.631L8 5a3 3 0 0 1 3 3l-.005.166 3.43 3.43C15.412 10.604 16 9.365 16 8"
        />
      </g>
    </svg>
  );
}
